module.exports = __webpack_public_path__ + "img/Microsoft-logo.e459eb56.svg";